export default function scrollToRef(ref: any, location: any) {
  if (ref.current && location.state) {
    ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.replaceState({}, "");
  }
}
